import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const labelTypography = (theme: Theme) => ({
  fontFamily: theme.typography.fontFamily,
  fontWeight: 500,
  fontStyle: "normal" as const,
  fontSize: "12px",
  lineHeight: "80%",
  letterSpacing: 0,
  textAlign: "right" as const,
  verticalAlign: "middle" as const,
});

const fieldTypography = (theme: Theme) => ({
  fontFamily: theme.typography.fontFamily,
  fontWeight: 400,
  fontStyle: "normal" as const,
  fontSize: "14px",
  lineHeight: "140%",
  letterSpacing: 0,
  textAlign: "right" as const,
  verticalAlign: "middle" as const,
});

const inputPadding = "12px 16px 12px 8px";

export const useStyles = makeStyles((theme: Theme) => ({
  pageRoot: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    direction: "rtl",
  },
  grid2: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: "10px",
    width: "100%",
    direction: "rtl",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    minWidth: 0,
    width: "100%",
    direction: "rtl",
    alignItems: "stretch",
  },
  label: {
    ...labelTypography(theme),
    margin: 0,
    padding: 0,
    color: theme.palette.text.primary,
    direction: "rtl",
    display: "block",
    width: "100%",
    boxSizing: "border-box",
  },
  selectControl: {
    margin: 0,
    width: "100%",
  },
  input: {
    direction: "rtl",
    margin: 0,
    opacity: 1,
    "& .MuiOutlinedInput-root": {
      margin: 0,
      height: 48,
      minHeight: 48,
      borderRadius: "4px",
      backgroundColor: theme.palette.background.paper,
      boxSizing: "border-box",
      alignItems: "center",
      opacity: 1,
      ...fieldTypography(theme),
      color: theme.palette.secondary.main,
      "& fieldset": {
        borderColor: theme.palette.divider,
        borderWidth: "1px",
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: inputPadding,
      direction: "rtl",
      width: "100%",
      height: "auto",
      boxSizing: "border-box",
      opacity: 1,
      ...fieldTypography(theme),
      color: theme.palette.secondary.main,
      "&::placeholder": {
        ...fieldTypography(theme),
        color: theme.palette.text.disabled,
        opacity: 1,
      },
    },
  },
  select: {
    direction: "rtl",
    height: 48,
    minHeight: 48,
    borderRadius: "4px",
    backgroundColor: theme.palette.background.paper,
    boxSizing: "border-box",
    opacity: 1,
    ...fieldTypography(theme),
    color: theme.palette.secondary.main,
    "& .MuiOutlinedInput-root": {
      height: 48,
      minHeight: 48,
      alignItems: "center",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.divider,
      borderWidth: "1px",
    },
    "& .MuiSelect-select": {
      padding: "12px 16px 12px 32px !important",
      direction: "rtl",
      boxSizing: "border-box",
      opacity: 1,
      ...fieldTypography(theme),
      color: theme.palette.secondary.main,
    },
    "& .MuiSelect-icon": {
      color: theme.palette.text.primary,
      fontSize: "18px !important",
      left: "8px !important",
      right: "auto !important",
    },
    "& .MuiSelect-iconOpen": {
      color: theme.palette.text.primary,
      fontSize: "18px !important",
      left: "8px !important",
      right: "auto !important",
    },
  },
  selectValue: {
    display: "block",
    width: "100%",
    direction: "rtl",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    opacity: 1,
    ...fieldTypography(theme),
    color: theme.palette.secondary.main,
  },
  selectPlaceholder: {
    display: "block",
    width: "100%",
    direction: "rtl",
    opacity: 1,
    ...fieldTypography(theme),
    color: theme.palette.text.disabled,
  },
}));
